import { removeImportance, markAsImportant } from '../strings.locstring.json';
import { taskImportantAriaText } from './TodoStarCharm.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { observer } from 'mobx-react';
import { StarCharm } from 'owa-star-charm';

const styles = require('./TodoStarCharm.scss');

export interface TodoStarCharmProps {
    onClick: () => void;
    isImportant: boolean;
    style: string;
}

@observer
export default class TodoStarCharm extends React.Component<TodoStarCharmProps, {}> {
    render() {
        const { isImportant, style } = this.props;
        return (
            <StarCharm
                isStarred={isImportant}
                onClick={this.onClick}
                iconStyles={styles.star}
                ariaLabelText={loc(taskImportantAriaText)}
                tooltip={{
                    starred: loc(removeImportance),
                    unstarred: loc(markAsImportant),
                }}
                buttonStyles={{ root: style }}
            />
        );
    }

    private onClick = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        this.props.onClick();
    };
}
